/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89370760dd7aca35aeecca1b17abbf42>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/page';
import NewObjectComponent from '@atlaskit/object/page';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/page/16';

/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Page16Icon = function Page16Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  // Feature flag to migrate to new object package
  if (fg('platform_dst_icon_object_to_object')) {
    // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/React.createElement(NewObjectComponent, {
      label: label,
      testId: testId,
      size: "medium"
    });
  }
  return /*#__PURE__*/React.createElement(IconTile, {
    icon: NewIcon,
    appearance: "blueBold",
    size: "16",
    label: label,
    testId: testId,
    LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    })
  });
};
Page16Icon.displayName = 'Page16Icon';
export default Page16Icon;